export default [
    {
        path: '/pages/group/productSeckillOrder',
        name: '/pages/group/productSeckillOrder',
        component: () => import('@/views/group/productSeckillOrder.vue')
    },
    {
        path: '/pages/group/adminSeckillOrder',
        name: '/pages/group/adminSeckillOrder',
        component: () => import('@/views/group/adminSeckillOrder.vue')
    },
    {
        path: '/pages/group/productGroupManage',
        name: '/pages/group/productGroupManage',
        component: () => import('@/views/group/productGroupManage.vue')
    },
    {
        path: '/pages/group/productGroupOrderManage',
        name: '/pages/group/productGroupOrderManage',
        component: () => import('@/views/group/productGroupOrderManage.vue')
    },
    {
        path: '/pages/group/productGroupOrderReturn',
        name: '/pages/group/productGroupOrderReturn',
        component: () => import('@/views/group/productGroupOrderReturn.vue')
    },
    {
        path: '/pages/group/productSeckillManage',
        name: '/pages/group/productSeckillManage',
        component: () => import('@/views/group/productSeckillManage.vue')
    },
    {
        path: '/pages/group/adminGroup',
        name: '/pages/group/adminGroup',
        component: () => import('@/views/group/adminGroup.vue')
    },
    {
        path: '/pages/group/adminGroupOrder',
        name: '/pages/group/adminGroupOrder',
        component: () => import('@/views/group/adminGroupOrder.vue')
    },
    {
        path: '/pages/group/adminRefundGroupOrder',
        name: '/pages/group/adminRefundGroupOrder',
        component: () => import('@/views/group/adminRefundGroupOrder.vue')
    },
    {
        path: '/pages/group/adminSeckill',
        name: '/pages/group/adminSeckill',
        component: () => import('@/views/group/adminSeckill.vue')
    }
] 